<style lang="scss">
.el-card__body:empty {
	display: none;
}
</style>
<style lang="scss" scoped>
.student-rules {
	&__header {
		height: 50px;
		@include flex-center;
		&__text {
			margin-left: 20px;
			width: 25%;
		}
	}
	&__text {
		padding: 20px;
		text-align: center;
	}
	&__col {
		width: 100%;
		padding-right: 20px;
		&:last-child {
			width: 50px;
			padding-right: 0;
		}
		.el-select {
			width: 100%;
		}
	}
	&__rules {
		margin-bottom: 10px;
		&__row {
			@include flex-center;
			margin-bottom: 10px;
			&__item {
				margin-right: 15px;
			}
		}
	}
}
</style>

<template lang="pug">
el-card.student-rules
    .clearfix(slot='header')
      .student-rules__header
        el-switch(v-model='active') 
        .student-rules__header__text Sync students
    loading(v-if='$apollo.loading')
</template>
<script>
import gql from "graphql-tag";
export default {
	data() {
		return {
			active: null
		};
	},

	watch: {
		active() {
			this.$emit("input", {
				active: this.active
			});
		}
	},

	apollo: {
		active: {
			query: gql`
				query Settings($type: SettingsTypeEnum!) {
							Settings(type: $type) {
								id
								student_active
							}
					}
			`,
			variables() {
				return {
					type: "organisation"
				}
			},
			update(r) {
				return r.Settings.student_active;
			}
		}
	}
};
</script>

